export const removeAccent = (value: string) =>
  value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
